import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { MultiProductInfoBlock as MultiProductInfoBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { richHTML } from "../../utils/html";

import styles from "./index.module.scss";

export const MultiProductInfoBlock = (
    block: Immutable<{ value: MultiProductInfoBlockValue }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.multiProductInfo,
            "pdp-features",
            block.value.background_style?.style ?? "",
            getGlobalSpacingClasses(block.value.spacing),
        ])}
    >
        {block.value.header || block.value.copy ? (
            <div className={styles.multiProductInfoHeader}>
                <h2 className={styles.multiProductInfoTitle}>
                    {block.value.header}
                </h2>
                <div
                    className={styles.multiProductInfoCopy}
                    dangerouslySetInnerHTML={richHTML(block.value.copy)}
                />
            </div>
        ) : null}
        <div className={styles.multiProductInfoBody}>
            {(block.value.products ?? []).map((product, index) => {
                const order = (index + 1) % 2 === 0 ? "even" : "odd";
                return (
                    <div
                        className={concatClassNames([
                            styles.productInfo,
                            order === "even" ? styles.productInfoEven : null,
                        ])}
                        key={index}
                    >
                        <div className={styles.productInfoProductImage}>
                            {product.image ? (
                                <img
                                    className="responsive-img"
                                    src={product.image.url}
                                    alt={product.header ?? ""}
                                    loading="lazy"
                                    decoding="async"
                                />
                            ) : null}
                        </div>
                        <div className={styles.productInfoContainer}>
                            <div
                                className={concatClassNames([
                                    styles.productInfoProductInfo,
                                    order === "even"
                                        ? styles.productInfoProductInfoEven
                                        : null,
                                ])}
                            >
                                <div
                                    className={
                                        styles.productInfoProductInfoInner
                                    }
                                >
                                    <h3
                                        className={
                                            styles.productInfoProductInfoHeader
                                        }
                                    >
                                        {product.header}
                                    </h3>
                                    <div
                                        className={
                                            styles.productInfoProductInfoCopy
                                        }
                                        dangerouslySetInnerHTML={richHTML(
                                            product.copy,
                                        )}
                                    />
                                    {product.page ? (
                                        <a
                                            className="button button--secondary"
                                            href={product.page.url}
                                        >
                                            {product.link_title}
                                        </a>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    </section>
);
